export const MIN_YEAR = 1850;
export const MAX_YEAR = 2025;
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
export const DAILY_API_URL = `${API_BASE_URL}/api/images`;

// Animation & Timing Constants
export const ANIMATION = {
  QUICK_DELAY: 50,
  SHORT_DELAY: 150,
  STANDARD_DELAY: 300,
  RETRY_DELAY: 1500,
  MESSAGE_DISPLAY: 2000,
  CONFETTI_DURATION: 3000,
  INSTRUCTIONS_FLIP: 4000,
  MODAL_CLOSE_DELAY: 100,
  SCORE_FADE_DURATION: 2500,
} as const;

// Scoring Algorithm Constants
export const SCORING = {
  PERFECT_SCORE: 1000,
  MAX_PENALTY_THRESHOLD: 50,
  CURVE_STEEPNESS: 0.752,
  BASE_SCALE: 3,
  SCALE_FACTOR: 5.8,
  SCALE_COEFFICIENT: 0.015,
  REFERENCE_YEAR: 1900,
  // Polynomial coefficients for scoring curve
  POLY_COEFF_CUBIC: 0.0281728,
  POLY_COEFF_QUADRATIC: -0.140864,
  POLY_COEFF_LINEAR: 0.35,
  ADJUSTMENT_FACTOR: 3.5216,
} as const;

// UI Dimensions & Breakpoints
export const UI = {
  MOBILE_BREAKPOINT: 768,
  AD_WIDTH_THRESHOLD: 250,
  LINE_HEIGHT_CAP: 47,
  CHART_MIN_WIDTH: 1000,
  CHART_DEFAULT_HEIGHT: 150,
  CHART_DEFAULT_WIDTH: 300,
  MIN_ZOOM: 1,
  MAX_ZOOM: 8,
  SCROLL_ZOOM_SENSITIVITY: 0.0015,
  BUTTON_ZOOM_FACTOR: 1.6,
  ZOOM_THRESHOLD: 0.01,
  DENSITY_BANDWIDTH: 125,
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  REQUEST_TIMEOUT: 408,
  CLIENT_CLOSED_REQUEST: 499,
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
} as const;

// Color Palette
export const COLORS = {
  PRIMARY_BACKGROUND: '#090312',
  SECONDARY_BACKGROUND: '#322A3F',
  MODAL_BACKGROUND: '#0D0713',
  CONTROL_BACKGROUND: '#1A1321',
  HOVER_COLOR: '#4A3D5F',
  PRIMARY_PURPLE: '#7236DC',
  PURPLE_HOVER: '#8347ED',
  ACCENT_PURPLE: '#C6A4FF',
  ACCENT_YELLOW: '#FFC300',
} as const;

// Z-Index Layers
export const Z_INDEX = {
  BACKGROUND: 0,
  BASE: 10,
  ELEVATED: 20,
  OVERLAY: 30,
  MODAL: 50,
  TOAST: 60,
  CRITICAL: 100,
  SUPER_CRITICAL: 110,
} as const;

// External URLs
export const URLS = {
  MAIN_SITE: 'https://whichyr.com',
  TWITTER: 'https://x.com/youbetchaaaaa',
  BLUESKY: 'https://bsky.app/profile/chriscreguer.bsky.social',
  SUPPORT: 'https://buymeacoffee.com/whichyr',
  GOOGLE_PRIVACY: 'https://www.google.com/policies/privacy/partners/',
} as const;

// Google Ads Configuration
export const ADS = {
  CLIENT_ID: 'ca-pub-7826259247816540',
  LEFT_SLOT: '4716703653',
  RIGHT_SLOT: '7342866999',
  RESULT_SLOT_1: '2116817820',
  RESULT_SLOT_2: '5188032820',
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  HAS_SEEN_INSTRUCTIONS: 'hasSeenInstructions',
  MIGRATION_FLAG: 'storageMigration_v2_Complete',
  SCORE_FIX_FLAG_PREFIX: 'hasFixedScore_',
} as const;

// Analytics Event Names
export const ANALYTICS_EVENTS = {
  SOCIAL_CLICK: 'social_click',
  SOCIAL_ENGAGEMENT: 'social_engagement',
  START_CHALLENGE: 'start_challenge',
  ROUND_COMPLETE: 'round_complete',
  CHALLENGE_COMPLETE: 'challenge_complete',
  OPEN_CALENDAR: 'open_calendar',
  SHARE_RESULTS: 'share_results',
} as const;

// CSS Class Names
export const CSS_CLASSES = {
  NO_SCROLL: 'no-scroll',
  YEAR_INPUT_PREFIX: 'year-input-',
} as const;
